import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDeleteOrgDialogData {
  displayName: string;
  userCount: number;
}

@Component({
  selector: 'app-confirm-delete-org-dialog',
  templateUrl: './confirm-delete-org-dialog.component.html',
})
export class ConfirmDeleteOrgDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteOrgDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteOrgDialogData,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
